import type {
  AppProfileWithId,
  AppSpec,
  AppStruct,
  ConnectorStruct,
  TriggerIntegrationSpec,
} from '@cohort/shared/schema/apps/app';
import type {OAuth2AppCredentials, OAuth2Credentials} from '@cohort/shared/schema/apps/oauth';
import {basicOauth2ConnectorSpec} from '@cohort/shared/schema/apps/oauth';
import {StravaBeActiveTriggerIntegrationSpec} from '@cohort/shared/schema/apps/strava/triggers/beActive';
import {StravaCompleteActivityTriggerIntegrationSpec} from '@cohort/shared/schema/apps/strava/triggers/completeActivity';
import {StravaActivityCreatedEventSpec} from '@cohort/shared/schema/apps/strava/userEvents/activityCreated';
import type {UserEventSpec, UserEventStruct} from '@cohort/shared/schema/apps/userEvent';

export const StravaTriggerIntegrationSpecs = [
  StravaBeActiveTriggerIntegrationSpec,
  StravaCompleteActivityTriggerIntegrationSpec,
] as const satisfies ReadonlyArray<TriggerIntegrationSpec>;

type StravaTriggerIntegrationIds = (typeof StravaTriggerIntegrationSpecs)[number]['id'];

export const StravaUserEventSpecs = [
  StravaActivityCreatedEventSpec,
] as const satisfies ReadonlyArray<UserEventSpec<StravaUserEventStruct>>;
type StravaUserEventIds = (typeof StravaUserEventSpecs)[number]['id'];

export type StravaConnectorStruct = ConnectorStruct<
  'strava',
  OAuth2AppCredentials,
  OAuth2Credentials,
  AppProfileWithId,
  null
>;

export type StravaAppStruct = AppStruct<
  'strava',
  null,
  StravaConnectorStruct,
  null,
  never,
  never,
  never,
  StravaTriggerIntegrationIds,
  StravaUserEventIds,
  never
>;

export const StravaConnectorSpec = basicOauth2ConnectorSpec<StravaConnectorStruct>('strava');

// TODO: try to get rid of this
export const StravaAppSpec: AppSpec<StravaAppStruct> = {
  id: 'strava',
  name: 'Strava',
  merchantConnector: null,
  userConnector: StravaConnectorSpec,
  usersSyncSpec: null,
  actionSpecs: [],
  notificationIntegrationSpecs: [],
  perkIntegrationSpecs: [],
  triggerIntegrationSpecs: StravaTriggerIntegrationSpecs,
  userEventSpecs: StravaUserEventSpecs,
  resourceSpecs: [],
};

type StravaEventResource = 'activity';
type StravaUserEventId = `strava.${StravaEventResource}.${string}`;
export type StravaUserEventStruct = UserEventStruct<StravaUserEventId>;
